export default __webpack_public_path__ + "static/media/PortfolioBuilderDemo.ac734330.mp4";